module.exports = __webpack_public_path__ + "img/advertising1.bbb85451.png";